import React, { useMemo } from "react";
import { formatCurrency } from "../../../../utils/SamuiUtils";

export default React.memo(function DataTable({
  fields,
  data,
  onSort,
  sortField,
  sortOrder,
  onRowClick,
  sums,
}) {


  return (
    <div className="card p-2">
      <div
        className="table-responsive"
        style={{ height: "70vh", overflowY: "auto" }}
      >
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>
              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    width: f.w,
                    cursor: f.sortable ? "pointer" : "default",
                  }}
                  className={`text-${f.alignHeader} text-nowrap`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.sortable && (
                    <span className="ms-1">
                      {f.key === sortField ? (
                        sortOrder === "asc" ? (
                          <i className="fas fa-sort-up text-white"></i>
                        ) : (
                          <i className="fas fa-sort-down text-white"></i>
                        )
                      ) : (
                        <i className="fas fa-sort text-muted" style={{ opacity: 0.5 }}></i>
                      )}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((item, i) => (
                <tr
                  key={i}
                  style={{ cursor: "pointer" }}
                  onClick={() => onRowClick(i)}
                >

                  {fields
                    .map((f) => {
                      if (f.key === "TotalQty") return item.TotalQty;
                      if (f.key === "total_customer")
                        return `${item.total_customer}`;
                      if (f.key === "total_customer_repeat")
                        return `${item.total_customer_repeat}`;
                      if (f.key === "repeat_rate")
                        return `${item.repeat_rate} %`;
                      if (f.numeric) return formatCurrency(item[f.key]);
                      return item[f.key];
                    })
                    .map((value, j) => (
                      <td key={j} className={`text-${fields[j].align}`}>
                        {value}
                      </td>
                    ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={fields.length + 1}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={6} className="text-end">
                รวมทั้งหมด {data.length} รายการ
              </th>
              <th colSpan={fields.length - 1} className="text-end">
                {formatCurrency(
                  data.reduce((s, d) => s + (d.Item_Total || 0), 0)
                )}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});